export const BOARD_NAMES_TO_GET = [
	"Users_list",
	"Prices_List",
	"Services",
	"Front_Access",
	"Conversion_list",
	"Marketing plan",
	"Briefs",
	"Subitems of Briefs",
	"Quotes",
	"Projects management",
	"Campains",
	"Notifications",
	"Supports / Tasks",
	"Subitems of Supports / Tasks",
	"Client Navigation",
] as const;

export type BoardName = (typeof BOARD_NAMES_TO_GET)[number];

export const BOARDS_MAPPER = {
	users: "Users_list",
	prices: "Prices_List",
	services: "Services",
	front: "Front_Access",
	conversions: "Conversion_list",
	marketingPlan: "Marketing plan",
	briefs: "Briefs",
	briefSubitems: "Subitems of Briefs",
	parentTasks: "Supports / Tasks",
	tasks: "Subitems of Supports / Tasks",
	quotes: "Quotes",
	projects: "Projects management",
	campaigns: "Campains",
	notifications: "Notifications",
	navigation: "Client Navigation",
} as const;

export enum BOARDS_KEY_MAPPER_ENUM {
	users = "users",
	prices = "prices",
	services = "services",
	front = "front",
	conversions = "conversions",
	marketingPlan = "marketingPlan",
	briefs = "briefs",
	briefSubitems = "briefSubitems",
	quotes = "quotes",
	projects = "projects",
	campaigns = "campaigns",
	navigation = "navigation",
	notifications = "notifications",
	tasks = "tasks",
	parentTasks = "parentTasks",
}

export type BoardMapperKey = keyof typeof BOARDS_MAPPER;
export type BoardMapper = Record<BoardMapperKey, string> | undefined;
